import { render } from "./Clickable.vue?vue&type=template&id=42a9b121&scoped=true"
import script from "./Clickable.vue?vue&type=script&lang=js"
export * from "./Clickable.vue?vue&type=script&lang=js"

import "./Clickable.vue?vue&type=style&index=0&id=42a9b121&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a9b121"]])

export default __exports__